import {VuexModule, Module, Mutation, Action} from 'vuex-module-decorators';
import AuthService from '@/services/AuthService';

@Module({namespaced: true})
class User extends VuexModule {
    public status = {loggedIn: false};
    public user = null;

    @Mutation
    public loginSuccess(user: any): void {
        this.status.loggedIn = true;
        this.user = user;
    }

    @Mutation
    public loginFailure(): void {
        this.status.loggedIn = false;
        this.user = null;
    }

    @Mutation
    public logout(): void {
        this.status.loggedIn = false;
        this.user = null;
    }

    @Mutation
    public registerSuccess(): void {
        this.status.loggedIn = false;
    }

    @Mutation
    public registerFailure(): void {
        this.status.loggedIn = false;
    }

    @Action({rawError: true})
    loadUser(): Promise<any> {
        console.log('loadUser');
        return AuthService.getUser()
            .then(user => {
                if (user !== "anonymousUser") {
                    this.context.commit('loginSuccess', user);
                }
            }).catch(() => {
                return Promise.resolve();
            });
    }

    @Action({rawError: true})
    login(data: any): Promise<any> {
        return AuthService.login(data.username, data.password)
            .then(() => {
                return this.context.dispatch('loadUser');
            })
            .then(
            () => {
                return Promise.resolve();
            },
            error => {
                this.context.commit('loginFailure');
                return Promise.reject("Login failed");
            }
        );
    }

    @Action
    signOut(): void {
        AuthService.logout();
        this.context.commit('logout');
    }


    get isLoggedIn(): boolean {
        return this.status.loggedIn;
    }
}

export default User;